export class NetworkHealthTracker {
  private static readonly HISTORY_LIMIT = 20; // Number of recent samples to keep
  private static readonly BAD_THRESHOLD = 5; // Network quality 5–6 is considered poor (according to Agora's docs)
  private static readonly MIN_BAD_COUNT = 10; // Minimum consecutive bad samples to mark as weak
  private static readonly MIN_GOOD_COUNT = 10; // Minimum consecutive good samples to mark as recovered
  private static readonly BAD_RATIO_THRESHOLD = 0.5; // Percentage of bad samples in history to consider weak

  private history: number[] = [];
  private badCount = 0;
  private goodCount = 0;
  private isWeak = false;

  /**
   * Update the network status based on the latest uplink and downlink values.
   * @param uplink - uplink quality score (1–6)
   * @param downlink - downlink quality score (1–6)
   * @returns true if network is weak, false otherwise
   */
  update(uplink: number, downlink: number): boolean {
    let score = Math.max(uplink, downlink);
    // Treat score 0 as score 1 (best quality)
    if (score === 0) {
      score = 1;
    }

    this.history.push(score);
    if (this.history.length > NetworkHealthTracker.HISTORY_LIMIT) {
      this.history.shift();
    }

    if (this.history.length < NetworkHealthTracker.HISTORY_LIMIT) {
      return this.isWeak;
    }

    const badRatio = this.history.filter((v) => v >= NetworkHealthTracker.BAD_THRESHOLD).length / NetworkHealthTracker.HISTORY_LIMIT;

    if (score >= NetworkHealthTracker.BAD_THRESHOLD) {
      this.badCount++;
      this.goodCount = 0;
    } else {
      this.goodCount++;
      if (this.goodCount >= NetworkHealthTracker.MIN_GOOD_COUNT) {
        this.badCount = 0;
        this.isWeak = false;
      }
    }

    if (this.badCount >= NetworkHealthTracker.MIN_BAD_COUNT || badRatio >= NetworkHealthTracker.BAD_RATIO_THRESHOLD) {
      this.isWeak = true;
    }

    return this.isWeak;
  }
}
